import React, { useEffect, useMemo, useState } from 'react'
import { FormCustom, TextArea } from '../../Components/Form/Form'
import ReactPlaceholder from 'react-placeholder/lib'
import { toast } from 'react-toastify'
import Controllers from '../../Api/Controllers'
import Helpers from '../../Components/Helpers/Helpers'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

const VacationForm = ({ vacationLeftDays, setReload, journeyWorker }) => {
  const [selectedDates, setSelectedDates] = useState([])
  const [holidays, setHolidays] = useState([])
  const [processing, setProcessing] = useState(false)
  const [comments, setComments] = useState('')

  useEffect(() => {
    const fetchHolidays = async () => {
      try {
        const res = await Controllers.vacation.get_holidays()
        if (res?.response === 'success' && Array.isArray(res.data)) {
          const holidayDates = res.data.map(date => new Date(date).toISOString().split('T')[0])
          setHolidays(holidayDates)
        }
      } catch (error) {
        Helpers.promise.catch({ req: error, toast })
      }
    }

    fetchHolidays()
  }, [])

  const filterDate = (date) => {
    const day = date.getDay()
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const formattedDate = date.toISOString().split('T')[0]

    const isHoliday = holidays.includes(formattedDate)

    return (
      date >= today &&
      !isHoliday &&
      ((journeyWorker === 'LUNES_VIERNES' && day >= 1 && day <= 5) ||
        (journeyWorker === 'LUNES_SABADO' && day >= 1 && day <= 6) ||
        journeyWorker === 'LUNES_DOMINGO')
    )
  }

  const handleDateClick = (date) => {
    const dateStr = date.toISOString().split('T')[0]
    const exists = selectedDates.find(d => d.toISOString().split('T')[0] === dateStr)
    if (exists) {
      setSelectedDates(selectedDates.filter(d => d.toISOString().split('T')[0] !== dateStr))
    } else {
      setSelectedDates([...selectedDates, date])
    }
  }

  const handleSubmit = async () => {
    if (selectedDates.length === 0) {
      Helpers.toast.construct({ response: 'warning', message: 'Debe seleccionar al menos un día', toast })
      return
    }

    if (selectedDates.length > vacationLeftDays) {
      Helpers.toast.construct({ response: 'warning', message: 'Los días solicitados superan los disponibles', toast })
      return
    }

    setProcessing(true)

    try {
      const formattedDates = selectedDates.map(d => d.toISOString().split('T')[0])

      const res = await Controllers.vacation.insert_update({
        p_selected_dates: formattedDates,
        p_vacation_days: formattedDates.length,
        p_journey_worker: journeyWorker,
        p_request_comments: comments,
      })

      Helpers.toast.construct({ ...res, toast })
      if (res.response === 'success') {
        setReload()
        setSelectedDates([])
        setComments('')
      }
    } catch (error) {
      Helpers.promise.catch({ req: error, toast })
    } finally {
      setProcessing(false)
    }
  }

  const requestedDays = selectedDates.length

  const datesList = useMemo(() => {
    return selectedDates
      .sort((a, b) => a - b)
      .map((date) => {
        const readable = date.toLocaleDateString('es-PE')
        const weekday = date.toLocaleDateString('es-PE', { weekday: 'long' })
        return `${readable} - ${weekday.charAt(0).toUpperCase() + weekday.slice(1)}`
      })
  }, [selectedDates])

  return (
    <ReactPlaceholder ready rows={5}>
      <FormCustom onSubmit={handleSubmit} loadSubmit={processing} viewSubmit>
        <div className="col-lg-6 col-md-12 mb-3">
          <div className="border rounded p-2 h-100">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div>
                <div className="font-weight-bold">Selecciona los días</div>
                <small className="text-muted">Jornada: {journeyWorker?.replace('_', ' ') || '—'} | No laborables deshabilitados</small>
              </div>
              {selectedDates.length > 0 && <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => setSelectedDates([])}>
                <i className="fa fa-eraser mr-1"></i> Limpiar
              </button>}
            </div>
            <DatePicker
              inline
              highlightDates={selectedDates}
              selected={null}
              onChange={handleDateClick}
              filterDate={filterDate}
              placeholderText="Selecciona fechas individuales"
              dateFormat="dd/MM/yyyy"
            />
          </div>
        </div>

        <div className="col-lg-6 col-md-12 mb-3">
          <div className="border rounded p-2 h-100 d-flex flex-column">
            <div className="d-flex align-items-center mb-2">
              <span className="mr-2">Días solicitados</span>
              <span className="badge badge-primary">{requestedDays}</span>
              <span className="mx-2">/</span>
              <span className="mr-2">Disponibles</span>
              <span className="badge badge-info">{vacationLeftDays}</span>
            </div>
            <div className="small text-muted mb-2">Detalle de días seleccionados</div>
            <div className="flex-grow-1 overflow-auto" style={{ maxHeight: 230 }}>
              {datesList.length === 0 ? <div className="text-muted small">No hay días seleccionados</div> : (
                <ul className="mb-0 pl-3">
                  {datesList.map((date, index) => (
                    <li key={index}>{date}</li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>

        <TextArea
          classNameParent="col-12 mb-3"
          text="Comentarios"
          value={comments}
          onChange={(e) => setComments(e.target.value)}
          required
          rows={4}
        />
      </FormCustom>
    </ReactPlaceholder>
  )
}

VacationForm.defaultProps = {
  vacationLeftDays: 0,
  setReload: () => { },
  journeyWorker: ''
}

export { VacationForm }


